// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__34Oc7","notes":"Notes_notes__28j1Y","note":"Notes_note__3ZNBh","markdown":"Notes_markdown__3TPne"};